import { Camera, Vector2 } from "three";
import { Marker3D } from "../domain";
import { ThreeAxisHelper } from '../view3d/three-axis-helper';
import { ScreenPoint } from "../view3d";
import BaseView from "./base-view";

export class Marker3DView extends BaseView {

    declare model: Marker3D;

    point: ScreenPoint;

    constructor(model: Marker3D) {
        super(model);
        this.point = new ScreenPoint();
        this.init();

        this.onReady.name = 'Marker3DView';
        this.onReady.trigger(); // born ready
    }

    protected make(): void {
        this.add(this.point);
    }

    protected bind(): void {
        // BaseView already binds our position, rotation, and scale
    }

    /**
     * Given a canvas and camera (or just the canvas' width and height), return
     * the 2D position of the marker an the screen as seen by the camera in the
     * 3D world.
     */
    toScreen(canvas: HTMLCanvasElement, camera: Camera, vec?: Vector2): Vector2;
    toScreen(width: number, height: number, camera: Camera, vec?: Vector2): Vector2;
    toScreen(a: HTMLCanvasElement | number,
             b : Camera | number,
             c: Vector2 | Camera,
             d?: Vector2)
    {
        if(a instanceof HTMLCanvasElement) {
            return this.point.toScreen(a.clientWidth, a.clientHeight, b as Camera, c as Vector2);
        } else {
            return this.point.toScreen(a, b as number, c as Camera, d as Vector2);
        }
    }

    debug() {
        const helper = new ThreeAxisHelper();
        this.add(helper);
    }
}
export default Marker3DView;



